import { render, staticRenderFns } from "./DigitalCollPlatform.vue?vue&type=template&id=97ec511c&scoped=true"
import script from "./DigitalCollPlatform.vue?vue&type=script&lang=js"
export * from "./DigitalCollPlatform.vue?vue&type=script&lang=js"
import style0 from "./DigitalCollPlatform.vue?vue&type=style&index=0&id=97ec511c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ec511c",
  null
  
)

export default component.exports